export default __webpack_public_path__ + "static/QuickBrush-Web-44703a2e983311a263765f5215966506.woff";